import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    number: '01',
    label: '🎁 BONO 1',
    title: 'Bases Nutricionales del Desarrollo Muscular',
    desc: 'El complemento nutricional que todo profesional del fitness necesita para responder con criterio. Sin teoría innecesaria. Directo a lo aplicable.',
    price: '$9.990 ARS'
  }, {
    number: '02',
    label: '🎁 BONO 2',
    title: 'La Práctica Profesional del Entrenador Personal',
    desc: 'Las herramientas concretas para ejercer con autoridad. Protocolos, criterios y recursos listos para usar en tu práctica diaria.',
    price: '$9.990 ARS'
  }];
  return <section className="py-12 bg-background-dark" data-id="element-37">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-38">
        <FadeIn className="text-center mb-10" data-id="element-39">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-40">
            Más los
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading mb-6" data-id="element-41">
            2 Bonos Estratégicos:
          </h3>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-42">
            Incluidos en todas las opciones — sin costo extra
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-43">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.2 + 0.1 * index} direction="up" data-id="element-44">
              <div className="bg-card-dark border border-primary/50 rounded-3xl p-6 md:p-8 h-full flex flex-col relative overflow-hidden group hover:border-primary transition-colors" data-id="element-45">
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl group-hover:bg-primary/10 transition-colors" data-id="element-46" />

                <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-47">
                  <span className="text-5xl font-black text-primary/20 font-heading" data-id="element-48">
                    {bonus.number}
                  </span>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20" data-id="element-49">
                    <span className="text-xs font-bold text-primary tracking-wider uppercase" data-id="element-50">
                      {bonus.label}
                    </span>
                  </div>
                </div>

                <h4 className="text-2xl font-bold text-white mb-4 relative z-10" data-id="element-51">
                  {bonus.title}
                </h4>

                <p className="text-gray-400 leading-relaxed mb-8 flex-1 relative z-10" data-id="element-52">
                  {bonus.desc}
                </p>

                <div className="flex items-end justify-between mt-auto relative z-10" data-id="element-53">
                  <span className="text-gray-500 line-through font-medium notranslate" translate="no" data-id="element-54">
                    {bonus.price}
                  </span>
                  <span className="bg-primary text-black font-black px-4 py-2 rounded-lg text-lg tracking-wide" data-id="element-55">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-56">
          <div className="bg-card-dark border-2 border-primary rounded-2xl p-6 text-center shadow-[0_0_20px_rgba(217,95,2,0.1)]" data-id="element-57">
            <span className="text-primary font-bold text-sm tracking-widest uppercase mb-2 block" data-id="element-58">
              🎁 VALOR TOTAL DE LOS BONOS
            </span>
            <h4 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-59">
              GRATIS — Solo en esta oferta
            </h4>
            <p className="text-gray-400" data-id="element-60">
              Incluidos en las 4 opciones. Siempre.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}